import * as actionTypes from '../actions/actionTypes';

import { updateObject } from '../utility';

const initialState = {
    departId: null,
    returnId: null,
    isDepartFlight: false,
    isReturnFlight: false,
    sidebar: false,
    departIndex: null,
    returnIndex: null,
    intIndex: null
}

const reducer = (state = initialState, action) => {
    switch(action.type) {
        case actionTypes.SET_DEPART_ID:
            return updateObject(state, { departId: action.val, isDepartFlight: true, sidebar: true, departIndex: action.index })
        case actionTypes.SET_RETURN_ID:
            return updateObject(state, { returnId: action.val, isReturnFlight: true, sidebar: true, returnIndex: action.index })
        case actionTypes.SET_INT_IDS:
            return updateObject(state, { departId: action.departId, returnId: action.returnId, isDepartFlight: true, isReturnFlight: true, sidebar: true, intIndex: action.tupleIndex })
        case actionTypes.CLEAR_FLIGHTS:
            return updateObject(state, { isDepartFlight: false, isReturnFlight: false })
        case actionTypes.TOGGLE_SIDEBAR:
            return updateObject(state, {sidebar: !state.sidebar})
        case actionTypes.CLOSE_SIDEBAR:
            return updateObject(state, {sidebar: false, isDepartFlight: false, isReturnFlight: false, departIndex: null, returnIndex: null})
        default:
            return state;
    }
}

export default reducer;


// WEBPACK FOOTER //
// ./src/store/reducers/roundTripSummary.js